<template>
  <div class="container">
    <div class="title">
      Firm's Projects-Emai
      <div class="search_right">
        <Input
          ref="inputSearchRef"
          v-model.trim="queryParam.KeyWord"
          search
          enter-button
          clearable
          placeholder="Please enter keyword"
          @on-search="getList()"
          @on-clear="getList(1)"
          class="input_search_clearable"
          style="width: 250px; margin-right: 10px"
        />
        <Button type="primary" @click="handleAdd" class="addAsset_btn"
          >Add</Button
        >
      </div>
    </div>
    <div style="clear: both; margin-bottom: 8px"></div>
    <!-- table -->
    <Card :padding="0" :shadow="false">
      <Table
        stripe
        ref="indexTable"
        :columns="Columns"
        :data="Data"
        :loading="isloading"
        :row-class-name="highlightName"
      ></Table>
    </Card>
    <!-- 分页 -->
    <div class="paging">
      <Page
        :total="pagenation.pageTotal"
        :current.sync="pagenation.pageCurrent"
        show-sizer
        show-elevator
        show-total
        @on-page-size-change="handlePagechange"
      />
    </div>
    <!-- 新增 -->
    <AddEdit ref="AddEdit" @Success="getList"></AddEdit>
    <!-- 删除 -->
    <Modal
      :width="654"
      v-model="isSureDelete"
      title="Delete"
      :styles="{ top: '100px' }"
    >
      <div>Are you sure to delete the Firm's Projects-Email？</div>
      <div slot="footer">
        <Button @click="cancelBtn">Cancel</Button>
        <Button type="error" @click="deleteSelete">Delete</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import apiRoutes from "@/config/API_ROUTER";
import { Modal } from "view-design";
import { FORMATDATE } from "@/tools/tools";
import AddEdit from "./components/AddEdit";

export default {
  components: { AddEdit, Modal },
  data() {
    return {
      queryParam: {
        KeyWord: "",
      },
      isSureDelete: false,
      Columns: [
        {
          title: "Project Name",
          key: "projects",
          tooltip: true,
        },
        {
          title: "Email Count",
          key: "emailCount",
          maxWidth: 180,
          align: "center",
        },
        {
          title: "Active",
          key: "isDelete",
          tooltip: true,
          align: "center",
          width: 150,
          render: (h, params) => {
            const e = params.row.isDelete;
            return h(
              "Tag",
              {
                attrs: {
                  color: e ? "red" : "blue",
                },
              },
              e ? "NO" : "YES"
            );
          },
        },
        {
          title: "Created Time",
          key: "creationTime",
          tooltip: true,
          maxWidth: 240,
          align: "center",
          render: (h, params) => {
            return h("div", FORMATDATE(params.row.creationTime));
          },
        },
        {
          title: "Operation",
          align: "center",
          minWidth: 120,
          maxWidth: 150,
          render: (h, record) => {
            return h("div", [
              h("i", {
                class: "mdi mdi-eye",
                style: {
                  marginRight: "8px",
                  color: "gray",
                  "font-size": "16px",
                  cursor: "pointer",
                },
                on: {
                  click: (event) => {
                    event.stopPropagation();
                    this.handlePreview(record);
                  },
                },
              }),
              h("i", {
                class: "mdi mdi-border-color",
                style: {
                  marginRight: "8px",
                  color: "#2db7f5",
                  "font-size": "16px",
                  cursor: "pointer",
                },
                on: {
                  click: (event) => {
                    event.stopPropagation();
                    this.handleEdit(record);
                  },
                },
              }),
              h("i", {
                class: "mdi mdi-delete",
                style: {
                  // marginRight: "15px",
                  color: "#ed4014",
                  "font-size": "16px",
                  cursor: "pointer",
                },
                on: {
                  click: (event) => {
                    event.stopPropagation();
                    this.handleDelete(record);
                  },
                },
              }),
            ]);
          },
        },
      ],
      Data: [],
      isloading: false,
      pagenation: {
        pageTotal: 0,
        pageCurrent: 1,
      },
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    // table数据
    getList(type) {
      // 代表重置
      if (type === 1) {
        this.queryParam.KeyWord = "";
      }
      // PageList
      const url = apiRoutes.PageList;
      this.$http
        .get(url, {
          params: this.queryParam,
        })
        .then((res) => {
          // console.log(res, "131213");
          const { data } = res.data;
          const { isSuccess } = res.data;
          if (isSuccess) {
            this.Data = data;
          }
          // console.log(data, "132131");
        });
    },
    // 分页改变
    handlePagechange() {},
    // 高亮
    highlightName(row) {
      if (row.highlight) {
        return "highlightClass";
      }
      return "";
    },
    // 新增
    handleAdd() {
      const type = "add";
      this.$refs.AddEdit.openDialog(type);
    },
    // 编辑
    handleEdit(record) {
      // console.log(record, "151515");
      const type = "edit";
      this.$refs.AddEdit.openDialog(type, record);
      // this.$refs.AddEdit.$emit('openDialogs',type,record)
    },
    // 删除
    handleDelete(record) {
      this.firmId = record.row.firmId;
      this.isSureDelete = true;
    },
    // 删除取消
    cancelBtn() {
      this.isSureDelete = false;
    },
    // 确定
    deleteSelete() {
      const url = apiRoutes.Firm;
      const params = {
        id: this.firmId,
      };
      this.$http
        .delete(url, {
          params,
        })
        .then((res) => {
          if (res.status === 200) {
            this.$Message.success("Success!");
            this.isSureDelete = false;
            this.getList();
          }
        });
    },
    // 预览
    handlePreview(record) {
      const type = "look";
      this.$refs.AddEdit.openDialog(type, record);
    },
  },
};
</script>
<style lang="less">
.container {
  width: 100%;
  min-height: 500px;
  background: #fff;
  padding: 16px;
  box-sizing: border-box;
  .title {
    border-left: 4px solid #515a6e;
    padding-left: 15px;
    font-weight: bold;
    .search_right {
      float: right;
      display: flex;
      position: relative;
      top: -4px;
    }
  }
  .paging {
    padding-top: 20px;
    padding-bottom: 150px;
    width: 100%;
    text-align: center;
  }
}
</style>
